import { GoogleAuthProvider, getAuth, signInWithCredential, signInWithPopup } from 'firebase/auth';

const auth = getAuth();

const loginWithGoogle = () => {
	const provider = new GoogleAuthProvider();
	return signInWithPopup(auth, provider);
};

const loginWithGoogleCredential = (token) => {
	const credential = GoogleAuthProvider.credential(token);
	return signInWithCredential(auth, credential);
};

const logoutUser = () => auth.signOut();

const FirebaseAuthService = {
	loginWithGoogle,
	loginWithGoogleCredential,
	logoutUser
};

export default FirebaseAuthService;
